var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD15C"
    },
    cx: 256,
    cy: 256,
    r: 209.067
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 386.133,
    cy: 338.133,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M390.4,315.733L390.4,315.733c-2.133,2.133-6.4,2.133-8.533,0l0,0 c-2.133-2.133-4.267-2.133-6.4-1.067c-9.6,4.267-17.067,12.8-17.067,23.467c0,10.667,6.4,19.2,17.067,23.467 c2.133,1.067,5.333,0,6.4-1.067l0,0c2.133-2.133,6.4-2.133,8.533,0l0,0c2.133,2.133,4.267,2.133,6.4,1.067 c9.6-4.267,17.067-12.8,17.067-23.467c0-10.667-6.4-19.2-17.067-23.467C394.667,313.6,392.533,314.667,390.4,315.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M376.533,338.133c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933c0-6.4,2.133-11.733,6.4-14.933c4.267-5.333,13.867-2.133,13.867,4.267 l0,0c0,1.067-1.067,2.133-1.067,3.2C377.6,332.8,376.533,334.933,376.533,338.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M372.267,339.2L372.267,339.2v-2.133c-1.067-1.067-4.267-1.067-5.333,0l-1.067,1.067l1.067,1.067 C368,340.267,371.2,340.267,372.267,339.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M375.467,330.667h1.067V329.6c-1.067-2.133-3.2-3.2-5.333-2.133h-1.067v1.067 C371.2,330.667,373.333,331.733,375.467,330.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M371.2,349.867h-1.067V348.8c1.067-2.133,3.2-3.2,5.333-2.133h1.067v1.067 C376.533,349.867,373.333,350.933,371.2,349.867z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M397.867,338.133c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867c0,5.333-2.133,9.6-5.333,13.867 c-4.267,5.333-12.8,2.133-12.8-4.267l0,0c0-1.067,0-2.133,1.067-3.2C396.8,343.467,397.867,341.333,397.867,338.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M403.2,337.067L403.2,337.067v2.133c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067l-1.067-1.067 C407.467,336,404.267,336,403.2,337.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M400,345.6h-1.067v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067v-1.067 C404.267,345.6,402.133,344.533,400,345.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M404.267,326.4h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133h-1.067v-1.067 C400,326.4,402.133,325.333,404.267,326.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.5227 -0.8525 0.8525 0.5227 -212.1448 450.9953)",
    style: {
      fill: "#FF7058"
    },
    cx: 296.698,
    cy: 414.958,
    rx: 30.933,
    ry: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M311.467,397.867L311.467,397.867c-3.2,1.067-6.4-1.067-7.467-4.267l0,0 c-1.067-2.133-2.133-4.267-5.333-4.267C288,387.2,277.333,391.467,272,401.067c-5.333,8.533-4.267,20.267,2.133,28.8 c1.067,2.133,4.267,3.2,6.4,2.133l0,0c3.2-1.067,6.4,1.067,7.467,4.267l0,0c1.067,2.133,2.133,4.267,5.333,4.267 C304,442.667,314.667,438.4,320,428.8c5.333-8.533,4.267-20.267-2.133-28.8C316.8,398.933,314.667,397.867,311.467,397.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M288,410.667c-1.067,2.133-2.133,5.333-1.067,7.467c0,1.067,0,2.133,0,3.2l0,0 c-3.2,6.4-12.8,3.2-14.933-3.2c-1.067-5.333,0-11.733,3.2-16c3.2-5.333,7.467-8.533,12.8-9.6c6.4-2.133,12.8,5.333,9.6,11.733l0,0 c-1.067,1.067-2.133,2.133-3.2,2.133C292.267,406.4,290.133,407.467,288,410.667z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M283.733,408.533h1.067v-1.067c-1.067-2.133-3.2-3.2-5.333-3.2H278.4v1.067 C279.467,407.467,281.6,409.6,283.733,408.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M291.2,403.2h1.067v-1.067c0-2.133-1.067-4.267-3.2-4.267H288v1.067 C288,401.067,289.067,403.2,291.2,403.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M277.333,418.133L277.333,418.133V416c2.133-1.067,4.267-1.067,5.333,1.067l1.067,1.067 l-1.067,1.067C281.6,419.2,279.467,419.2,277.333,418.133z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M306.133,421.333c1.067-2.133,1.067-4.267,1.067-7.467c0-1.067,0-2.133,0-3.2l0,0 c3.2-5.333,11.733-3.2,12.8,3.2c1.067,5.333,0,9.6-3.2,14.933c-3.2,4.267-7.467,7.467-11.733,8.533 c-6.4,2.133-11.733-5.333-8.533-10.667l0,0c1.067-1.067,1.067-2.133,3.2-2.133C302.933,424.533,305.067,423.467,306.133,421.333z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M311.467,423.467H310.4v1.067c1.067,2.133,3.2,3.2,5.333,3.2h1.067v-1.067 C315.733,424.533,313.6,422.4,311.467,423.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M304,428.8h-1.067v1.067c0,2.133,1.067,4.267,3.2,4.267h1.067v-1.067 C307.2,430.933,306.133,428.8,304,428.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M317.867,413.867L317.867,413.867V416c-2.133,1.067-4.267,1.067-5.333-1.067l-1.067-1.067 l1.067-1.067C313.6,412.8,316.8,412.8,317.867,413.867z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 292.267,
    cy: 333.867,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M296.533,310.4L296.533,310.4c-2.133,2.133-6.4,2.133-8.533,0l0,0 c-2.133-2.133-4.267-2.133-6.4-1.067c-9.6,4.267-17.067,12.8-17.067,23.467s6.4,19.2,17.067,23.467c2.133,1.067,5.333,0,6.4-1.067 l0,0c2.133-2.133,6.4-2.133,8.533,0l0,0c2.133,2.133,4.267,2.133,6.4,1.067C312.533,352,320,343.467,320,332.8 s-6.4-19.2-17.067-23.467C300.8,308.267,298.667,309.333,296.533,310.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M282.667,333.867c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933c0-5.333,2.133-11.733,6.4-14.933 c4.267-5.333,13.867-2.133,13.867,4.267l0,0c0,1.067-1.067,2.133-1.067,3.2C283.733,327.467,282.667,330.667,282.667,333.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M278.4,333.867L278.4,333.867v-2.133c-1.067-1.067-4.267-1.067-5.333,0L272,332.8l1.067,1.067 C274.133,336,277.333,336,278.4,333.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M281.6,326.4h1.067v-1.067c-1.067-2.133-3.2-3.2-5.333-2.133h-1.067v1.067 C277.333,325.333,279.467,326.4,281.6,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M277.333,345.6h-1.067v-1.067c1.067-2.133,3.2-3.2,5.333-2.133h1.067v1.067 C281.6,344.533,279.467,345.6,277.333,345.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M304,333.867c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867s-2.133,9.6-5.333,13.867c-4.267,5.333-12.8,2.133-12.8-4.267l0,0 c0-1.067,0-2.133,1.067-3.2C302.933,338.133,304,336,304,333.867z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M309.333,332.8L309.333,332.8v2.133c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067l-1.067-1.067 C313.6,330.667,310.4,330.667,309.333,332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M306.133,340.267h-1.067v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067V342.4 C310.4,341.333,308.267,340.267,306.133,340.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M310.4,321.067h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133h-1.067V323.2 C305.067,322.133,308.267,321.067,310.4,321.067z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7988 -0.6016 0.6016 -0.7988 10.2456 612.658)",
    style: {
      fill: "#FF7058"
    },
    cx: 107.573,
    cy: 304.616,
    rx: 30.933,
    ry: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M92.8,288L92.8,288c0,3.2-2.133,6.4-5.333,6.4l0,0c-2.133,0-4.267,2.133-5.333,4.267 c-3.2,10.667,0,21.333,8.533,27.733c8.533,6.4,20.267,6.4,28.8,1.067c2.133-1.067,3.2-3.2,3.2-6.4l0,0c0-3.2,2.133-6.4,5.333-6.4 l0,0c2.133,0,4.267-2.133,5.333-4.267c3.2-10.667,0-21.333-8.533-27.733c-8.533-6.4-20.267-6.4-28.8-1.067 C93.867,282.667,92.8,284.8,92.8,288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M102.4,312.533c2.133,2.133,5.333,2.133,7.467,2.133c1.067,0,2.133,0,3.2,1.067l0,0 C118.4,320,115.2,329.6,108.8,329.6c-5.333,0-11.733-1.067-16-4.267s-7.467-9.6-8.533-14.933c-1.067-7.467,6.4-12.8,12.8-8.533l0,0 c1.067,1.067,2.133,2.133,2.133,3.2C99.2,308.267,100.267,310.4,102.4,312.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M100.267,315.733v-1.067H99.2c-2.133,1.067-3.2,3.2-3.2,5.333v1.067h1.067 C99.2,320,100.267,317.867,100.267,315.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M96,308.267V307.2h-1.067c-2.133-1.067-4.267,1.067-5.333,3.2v1.067h1.067 C92.8,311.467,96,310.4,96,308.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M108.8,323.2l-1.067,1.067l-1.067-1.067c-1.067-2.133-1.067-4.267,1.067-5.333l1.067-1.067 l1.067,1.067C110.933,320,110.933,322.133,108.8,323.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M115.2,295.467c-2.133-1.067-4.267-2.133-7.467-1.067c-1.067,0-2.133,0-3.2-1.067l0,0 c-5.333-4.267-2.133-11.733,4.267-12.8c5.333,0,9.6,1.067,13.867,4.267c4.267,3.2,6.4,7.467,7.467,12.8 c1.067,6.4-6.4,11.733-10.667,7.467l0,0c-1.067-1.067-1.067-2.133-2.133-3.2C118.4,299.733,117.333,296.533,115.2,295.467z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M117.333,290.133v1.067h1.067c2.133,0,3.2-2.133,3.2-4.267v-1.067h-1.067 C119.467,285.867,117.333,288,117.333,290.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M121.6,297.6v1.067h1.067c2.133,1.067,4.267-1.067,5.333-3.2V294.4h-1.067 C124.8,294.4,122.667,296.533,121.6,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M109.867,283.733l1.067-1.067l1.067,1.067c1.067,2.133,1.067,4.267-1.067,5.333l-1.067,1.067 l-1.067-1.067C106.667,286.933,107.733,284.8,109.867,283.733z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.6171 -0.7869 0.7869 0.6171 -173.4305 262.7979)",
    style: {
      fill: "#FF7058"
    },
    cx: 183.315,
    cy: 309.602,
    rx: 30.934,
    ry: 34.134
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M200.533,294.4L200.533,294.4c-3.2,0-6.4-2.133-6.4-5.333l0,0c0-2.133-2.133-4.267-4.267-5.333 c-10.667-3.2-21.333,0-27.733,8.533c-6.4,8.533-6.4,20.267-1.067,28.8c1.067,2.133,3.2,3.2,6.4,3.2l0,0c3.2,0,6.4,2.133,6.4,5.333 l0,0c0,2.133,2.133,4.267,4.267,5.333c10.667,3.2,21.333,0,27.733-8.533c6.4-8.533,6.4-20.267,1.067-28.8 C204.8,295.467,202.667,294.4,200.533,294.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M174.933,302.933c-2.133,2.133-2.133,5.333-2.133,7.467c0,1.067,0,2.133-1.067,3.2l0,0 c-4.267,5.333-13.867,2.133-13.867-5.333c0-5.333,1.067-11.733,5.333-16s8.533-7.467,13.867-8.533 c7.467-1.067,12.8,7.467,8.533,12.8l0,0c-1.067,1.067-2.133,2.133-3.2,2.133C180.267,299.733,177.067,300.8,174.933,302.933z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M171.733,300.8h1.067v-1.067c0-2.133-2.133-3.2-4.267-3.2h-1.067v1.067 C167.467,299.733,169.6,301.867,171.733,300.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M179.2,297.6h1.067v-1.067c1.067-2.133,0-4.267-2.133-5.333h-1.067v1.067 C176,294.4,177.067,296.533,179.2,297.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M164.267,309.333l-1.067-1.067l1.067-1.067c2.133-1.067,4.267,0,5.333,1.067l1.067,1.067 L169.6,310.4C167.467,311.467,165.333,311.467,164.267,309.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M192,315.733c1.067-2.133,2.133-4.267,2.133-7.467c0-1.067,0-2.133,1.067-3.2l0,0 c4.267-5.333,11.733-2.133,12.8,4.267c0,5.333-1.067,9.6-4.267,13.867c-3.2,4.267-7.467,6.4-12.8,7.467 c-6.4,1.067-10.667-6.4-7.467-10.667l0,0c1.067-1.067,2.133-1.067,3.2-1.067C187.733,318.933,189.867,317.867,192,315.733z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M197.333,318.933h-1.067V320c0,2.133,2.133,3.2,4.267,3.2h1.067v-1.067 C200.533,320,199.467,318.933,197.333,318.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M188.8,323.2h-1.067v1.067c-1.067,2.133,0,4.267,2.133,5.333h1.067v-1.067 C192,326.4,190.933,324.267,188.8,323.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M203.733,310.4l1.067,1.067l-1.067,1.067c-2.133,1.067-4.267,0-5.333-1.067l-1.067-1.067 l1.067-1.067C200.533,308.267,202.667,309.333,203.733,310.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 334.933,
    cy: 230.4,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M339.2,208L339.2,208c-2.133,2.133-6.4,2.133-8.533,0l0,0c-2.133-2.133-4.267-2.133-6.4-1.067 c-9.6,4.267-17.067,12.8-17.067,23.467s6.4,19.2,17.067,23.467c2.133,1.067,5.333,0,6.4-1.067l0,0c2.133-2.133,6.4-2.133,8.533,0 l0,0c2.133,2.133,4.267,2.133,6.4,1.067c9.6-4.267,17.067-12.8,17.067-23.467s-6.4-19.2-17.067-23.467 C343.467,205.867,340.267,206.933,339.2,208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M325.333,230.4c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933s2.133-11.733,6.4-14.933c4.267-5.333,13.867-2.133,13.867,4.267l0,0 c0,1.067-1.067,2.133-1.067,3.2C326.4,225.067,325.333,228.267,325.333,230.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M321.067,231.467L321.067,231.467v-2.133c-1.067-1.067-4.267-1.067-5.333,0l-1.067,1.067 l1.067,1.067C316.8,232.533,318.933,232.533,321.067,231.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M324.267,224h1.067v-1.067c-1.067-2.133-3.2-3.2-5.333-2.133h-1.067v1.067 C320,222.933,322.133,224,324.267,224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M320,242.133h-1.067v-1.067c1.067-2.133,3.2-3.2,5.333-2.133h1.067V240 C324.267,242.133,322.133,243.2,320,242.133z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M345.6,230.4c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867s-2.133,9.6-5.333,13.867c-4.267,5.333-12.8,2.133-12.8-4.267l0,0 c0-1.067,0-2.133,1.067-3.2C344.533,235.733,345.6,233.6,345.6,230.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M352,229.333L352,229.333v2.133c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067l-1.067-1.067 C355.2,228.267,353.067,228.267,352,229.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M347.733,237.867h-1.067v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067V240 C352,237.867,349.867,236.8,347.733,237.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M352,218.667h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133h-1.067V220.8 C347.733,218.667,349.867,217.6,352,218.667z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.2677 -0.9635 0.9635 -0.2677 39.9259 461.4235)",
    style: {
      fill: "#FF7058"
    },
    cx: 195.313,
    cy: 215.539,
    rx: 30.933,
    ry: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M194.133,192L194.133,192c-2.133,3.2-5.333,4.267-8.533,2.133l0,0 c-2.133-1.067-4.267-1.067-6.4,1.067c-8.533,6.4-12.8,17.067-9.6,27.733C172.8,233.6,181.333,240,192,241.067 c2.133,0,5.333-1.067,6.4-3.2l0,0c2.133-3.2,5.333-4.267,8.533-2.133l0,0c2.133,1.067,4.267,1.067,6.4-1.067 c8.533-6.4,12.8-17.067,9.6-27.733c-3.2-10.667-11.733-17.067-22.4-18.133C197.333,188.8,195.2,189.867,194.133,192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M186.667,217.6c1.067,3.2,3.2,5.333,5.333,6.4c1.067,1.067,2.133,2.133,2.133,3.2l0,0 c2.133,6.4-6.4,11.733-12.8,8.533c-4.267-3.2-8.533-7.467-9.6-12.8c-1.067-5.333-1.067-11.733,2.133-16 c3.2-6.4,12.8-6.4,14.933,1.067l0,0c0,1.067,0,2.133-1.067,3.2C185.6,212.267,185.6,214.4,186.667,217.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M182.4,219.733l1.067-1.067l-2.133-1.067c-2.133-1.067-4.267,0-5.333,1.067l-1.067,1.067L176,220.8 C179.2,221.867,181.333,221.867,182.4,219.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M183.467,211.2l1.067-1.067l-1.067-1.067c-1.067-2.133-3.2-2.133-5.333-1.067l-1.067,1.067 l1.067,1.067C179.2,212.267,181.333,212.267,183.467,211.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M184.533,230.4h-1.067v-1.067c0-2.133,2.133-3.2,4.267-3.2h1.067v1.067 C188.8,229.333,186.667,230.4,184.533,230.4z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M205.867,212.267c-1.067-2.133-2.133-4.267-4.267-5.333c-1.067,0-2.133-1.067-2.133-2.133l0,0 c-2.133-6.4,5.333-10.667,10.667-7.467c4.267,3.2,7.467,6.4,8.533,11.733c1.067,5.333,1.067,10.667-1.067,14.933 c-3.2,5.333-11.733,5.333-12.8-1.067l0,0c0-1.067,0-2.133,0-3.2C206.933,217.6,206.933,214.4,205.867,212.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M211.2,210.133l-1.067,1.067l1.067,1.067c2.133,1.067,4.267,0,5.333-1.067l1.067-1.067l-1.067-1.067 C215.467,206.933,212.267,208,211.2,210.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M210.133,218.667l-1.067,1.067l1.067,1.067c1.067,2.133,3.2,2.133,5.333,1.067l1.067-1.067 l-1.067-1.067C214.4,217.6,212.267,217.6,210.133,218.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M209.067,198.4h1.067v1.067c0,2.133-2.133,3.2-4.267,3.2H204.8V201.6 C204.8,200.533,206.933,198.4,209.067,198.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 275.2,
    cy: 98.133,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M279.467,75.733L279.467,75.733c-2.133,2.133-6.4,2.133-8.533,0l0,0 c-1.067-2.133-4.267-2.133-6.4-1.067c-9.6,4.267-17.067,12.8-17.067,23.467s6.4,19.2,17.067,23.467c2.133,1.067,5.333,0,6.4-1.067 l0,0c2.133-2.133,6.4-2.133,8.533,0l0,0c2.133,2.133,4.267,2.133,6.4,1.067c9.6-4.267,17.067-12.8,17.067-23.467 s-6.4-20.267-16-23.467C283.733,73.6,281.6,73.6,279.467,75.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M265.6,98.133c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933c0-6.4,2.133-11.733,6.4-14.933c4.267-5.333,13.867-2.133,13.867,4.267 l0,0c0,1.067-1.067,2.133-1.067,3.2C266.667,92.8,265.6,94.933,265.6,98.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M261.333,99.2L261.333,99.2v-2.133c-1.067-1.067-4.267-1.067-5.333,0l-1.067,1.067L256,99.2 C257.067,100.267,260.267,100.267,261.333,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M264.533,90.667h1.067V89.6c-1.067-2.133-3.2-3.2-5.333-2.133H259.2v1.067 C260.267,90.667,263.467,91.733,264.533,90.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M260.267,109.867H259.2V108.8c1.067-2.133,3.2-3.2,5.333-2.133h1.067v1.067 C265.6,109.867,262.4,110.933,260.267,109.867z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M286.933,98.133c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867s-2.133,9.6-5.333,13.867c-4.267,5.333-12.8,2.133-12.8-4.267l0,0 c0-1.067,0-2.133,1.067-3.2C285.867,102.4,286.933,100.267,286.933,98.133z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M292.267,97.067L292.267,97.067V99.2c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067l-1.067-1.067 C296.533,96,294.4,96,292.267,97.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M289.067,105.6H288v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067v-1.067 C293.333,105.6,291.2,104.533,289.067,105.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M293.333,86.4h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133H288v-1.067 C289.067,86.4,291.2,85.333,293.333,86.4z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 397.867,
    cy: 172.8,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M402.133,150.4L402.133,150.4c-2.133,2.133-6.4,2.133-8.533,0l0,0 c-2.133-2.133-4.267-2.133-6.4-1.067c-9.6,4.267-17.067,12.8-17.067,23.467c0,10.667,6.4,19.2,17.067,23.467 c2.133,1.067,5.333,0,6.4-1.067l0,0c2.133-2.133,6.4-2.133,8.533,0l0,0c2.133,2.133,4.267,2.133,6.4,1.067 c9.6-4.267,17.067-12.8,17.067-23.467c0-10.667-6.4-19.2-17.067-23.467C406.4,148.267,404.267,149.333,402.133,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M388.267,172.8c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933c0-5.333,2.133-11.733,6.4-14.933 c4.267-5.333,13.867-2.133,13.867,4.267l0,0c0,1.067-1.067,2.133-1.067,3.2C389.333,167.467,388.267,169.6,388.267,172.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M384,173.867L384,173.867v-2.133c-1.067-1.067-4.267-1.067-5.333,0L377.6,172.8l1.067,1.067 C379.733,174.933,382.933,174.933,384,173.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M387.2,165.333h1.067v-1.067c-1.067-2.133-3.2-3.2-5.333-2.133h-1.067v1.067 C382.933,165.333,385.067,166.4,387.2,165.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M382.933,184.533h-1.067v-1.067c1.067-2.133,3.2-3.2,5.333-2.133h1.067v1.067 C387.2,184.533,385.067,185.6,382.933,184.533z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M409.6,172.8c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867c0,5.333-2.133,9.6-5.333,13.867 c-4.267,5.333-12.8,2.133-12.8-4.267l0,0c0-1.067,0-2.133,1.067-3.2C408.533,178.133,409.6,176,409.6,172.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M414.933,171.733L414.933,171.733v2.133c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067l-1.067-1.067 C419.2,170.667,416,170.667,414.933,171.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M411.733,180.267h-1.067v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067V182.4 C416,180.267,413.867,179.2,411.733,180.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M416,161.067h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133h-1.067V163.2 C411.733,161.067,413.867,160,416,161.067z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF7058"
    },
    cx: 144,
    cy: 164.267,
    rx: 34.133,
    ry: 30.933
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M148.267,141.867L148.267,141.867c-2.133,2.133-6.4,2.133-8.533,0l0,0 c-2.133-2.133-4.267-2.133-6.4-1.067c-9.6,4.267-17.067,12.8-17.067,23.467c0,10.667,6.4,19.2,17.067,23.467 c2.133,1.067,5.333,0,6.4-1.067l0,0c2.133-2.133,6.4-2.133,8.533,0l0,0c2.133,2.133,4.267,2.133,6.4,1.067 c9.6-4.267,17.067-12.8,17.067-23.467s-6.4-19.2-17.067-23.467C152.533,139.733,150.4,139.733,148.267,141.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M134.4,164.267c0,3.2,1.067,5.333,3.2,7.467c1.067,1.067,1.067,2.133,1.067,3.2l0,0 c0,7.467-9.6,9.6-13.867,4.267c-3.2-4.267-6.4-9.6-6.4-14.933c0-6.4,2.133-11.733,6.4-14.933c4.267-5.333,13.867-2.133,13.867,4.267 l0,0c0,1.067-1.067,2.133-1.067,3.2C135.467,157.867,134.4,161.067,134.4,164.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M130.133,164.267L130.133,164.267v-2.133c-1.067-1.067-4.267-1.067-5.333,0l-1.067,1.067 l1.067,1.067C125.867,166.4,128,166.4,130.133,164.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M133.333,156.8h1.067v-1.067c-1.067-2.133-3.2-3.2-5.333-2.133H128v1.067 C129.067,156.8,131.2,157.867,133.333,156.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M129.067,176H128v-1.067c1.067-2.133,3.2-3.2,5.333-2.133h1.067v1.067 C133.333,174.933,131.2,176,129.067,176z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M155.733,164.267c0-2.133-1.067-5.333-3.2-6.4c-1.067-1.067-1.067-2.133-1.067-3.2l0,0 c0-6.4,8.533-8.533,12.8-4.267c3.2,4.267,5.333,8.533,5.333,13.867c0,5.333-2.133,9.6-5.333,13.867 c-4.267,5.333-12.8,2.133-12.8-4.267l0,0c0-1.067,0-2.133,1.067-3.2C153.6,168.533,155.733,166.4,155.733,164.267z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M161.067,163.2L161.067,163.2v2.133c1.067,1.067,4.267,1.067,5.333,0l1.067-1.067L166.4,163.2 C165.333,161.067,162.133,161.067,161.067,163.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M157.867,170.667H156.8v1.067c1.067,2.133,3.2,3.2,5.333,2.133h1.067V172.8 C162.133,171.733,158.933,170.667,157.867,170.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M162.133,151.467h1.067v1.067c-1.067,2.133-3.2,3.2-5.333,2.133H156.8V153.6 C156.8,152.533,160,151.467,162.133,151.467z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M341.333,402.133c-1.067-7.467,6.4-14.933,14.933-16c8.533-1.067,19.2,3.2,19.2,10.667 c1.067,7.467-9.6,14.933-18.133,16C349.867,412.8,342.4,409.6,341.333,402.133z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 366.933,
    cy: 396.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M330.667,277.333c7.467-2.133,16,3.2,18.133,11.733c2.133,8.533,0,19.2-7.467,21.333 c-7.467,2.133-16-7.467-18.133-14.933C322.133,286.933,324.267,278.4,330.667,277.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 340.267,
    cy: 300.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M234.667,408.533c7.467-2.133,16,3.2,18.133,11.733c2.133,8.533,0,19.2-7.467,21.333 c-7.467,2.133-16-7.467-18.133-14.933C225.067,419.2,227.2,410.667,234.667,408.533z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 243.2,
    cy: 433.067,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M235.733,356.267c-5.333,5.333-16,5.333-21.333,0s-9.6-17.067-5.333-21.333s17.067-2.133,23.467,3.2 C238.933,343.467,241.067,352,235.733,356.267z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 215.467,
    cy: 341.333,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M254.933,160c-4.267-6.4-2.133-16,4.267-21.333c6.4-5.333,18.133-6.4,22.4-1.067 c4.267,6.4,0,18.133-7.467,22.4C266.667,164.267,259.2,165.333,254.933,160z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 273.067,
    cy: 141.867,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M298.667,217.6c-5.333,5.333-16,5.333-21.333,0c-5.333-5.333-9.6-17.067-5.333-21.333 s17.067-2.133,23.467,3.2C300.8,204.8,302.933,212.267,298.667,217.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 278.4,
    cy: 201.6,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#40596B"
    },
    d: "M441.6,215.467c1.067,7.467-6.4,14.933-13.867,16c-8.533,1.067-19.2-3.2-20.267-10.667 c-1.067-7.467,9.6-14.933,18.133-16C434.133,203.733,441.6,208,441.6,215.467z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#334A5E"
    },
    cx: 417.067,
    cy: 220.8,
    r: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.6,92.8c-7.467-18.133-27.733-25.6-45.867-18.133c-17.067,7.467-25.6,28.8-17.067,46.933 c2.133,4.267,2.133,2.133,5.333,5.333c2.133,2.133,6.4,3.2,9.6,2.133l0,0c5.333-2.133,11.733,1.067,12.8,7.467l2.133,9.6 c1.067,6.4,7.467,9.6,12.8,7.467l12.8-5.333c5.333-2.133,7.467-9.6,4.267-13.867l-5.333-7.467c-3.2-5.333-1.067-11.733,4.267-13.867 l0,0c3.2-1.067,5.333-4.267,5.333-8.533C234.667,97.067,235.733,97.067,233.6,92.8z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M224,141.867l-12.8,5.333c-4.267,2.133-8.533,0-11.733-3.2l0,0c1.067,6.4,7.467,9.6,12.8,7.467 l12.8-5.333c5.333-2.133,7.467-9.6,4.267-13.867l0,0C230.4,136.533,228.267,140.8,224,141.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M197.333,131.2L197.333,131.2c-1.067-6.4-7.467-9.6-12.8-7.467l0,0 c-3.2,1.067-7.467,1.067-9.6-2.133c-2.133-2.133-3.2-2.133-4.267-4.267c0,1.067,0,2.133,1.067,2.133 c2.133,4.267,2.133,2.133,5.333,5.333c2.133,2.133,6.4,3.2,9.6,2.133l0,0C189.867,125.867,195.2,128,197.333,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M232.533,98.133c0,3.2-2.133,6.4-5.333,8.533c-5.333,2.133-7.467,9.6-4.267,13.867l0,0 c-1.067-4.267,1.067-8.533,5.333-10.667c3.2-1.067,5.333-4.267,5.333-8.533c0-4.267,1.067-4.267-1.067-8.533 c0,0,0-1.067-1.067-1.067C233.6,93.867,232.533,94.933,232.533,98.133z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M362.667,160c12.8-14.933,10.667-36.267-4.267-49.067c-14.933-11.733-37.333-9.6-49.067,5.333 c-2.133,3.2-1.067,3.2-2.133,7.467c-1.067,3.2,0,7.467,3.2,9.6l0,0c4.267,4.267,4.267,10.667,0,14.933l-7.467,5.333 c-4.267,3.2-5.333,10.667,0,14.933l10.667,8.533c4.267,4.267,11.733,2.133,13.867-3.2l4.267-8.533c3.2-5.333,9.6-6.4,13.867-3.2l0,0 c3.2,2.133,6.4,3.2,9.6,1.067C359.467,162.133,359.467,163.2,362.667,160z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M314.667,173.867L304,165.333c-3.2-3.2-4.267-7.467-2.133-11.733l0,0 c-4.267,3.2-5.333,10.667,0,14.933l10.667,8.533c4.267,4.267,11.733,2.133,13.867-3.2l0,0 C323.2,177.067,318.933,177.067,314.667,173.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M311.467,145.067L311.467,145.067c5.333-3.2,5.333-10.667,0-14.933l0,0 c-2.133-2.133-3.2-6.4-2.133-9.6c1.067-3.2,0-4.267,2.133-6.4c-1.067,1.067-1.067,1.067-2.133,2.133 c-2.133,3.2-1.067,3.2-2.133,7.467c-1.067,3.2,0,7.467,3.2,9.6l0,0C313.6,136.533,313.6,140.8,311.467,145.067z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M358.4,161.067c-3.2,2.133-7.467,1.067-9.6-1.067c-4.267-4.267-11.733-2.133-13.867,3.2l0,0 c3.2-2.133,8.533-3.2,11.733,0c3.2,2.133,6.4,3.2,9.6,1.067c4.267-2.133,4.267-1.067,7.467-4.267l1.067-1.067 C361.6,160,361.6,160,358.4,161.067z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M379.733,288c9.6,16,32,21.333,48,10.667c16-10.667,21.333-33.067,9.6-49.067 c-2.133-3.2-3.2-2.133-6.4-4.267c-3.2-2.133-6.4-2.133-9.6,0l0,0C416,248.533,409.6,246.4,407.467,240l-2.133-7.467 C403.2,227.2,396.8,224,391.467,227.2l-11.733,7.467c-5.333,3.2-6.4,10.667-2.133,14.933l6.4,6.4 c4.267,4.267,3.2,11.733-2.133,14.933l0,0c-3.2,2.133-5.333,5.333-4.267,8.533C378.667,283.733,377.6,283.733,379.733,288z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M381.867,237.867L393.6,230.4c4.267-2.133,8.533-1.067,11.733,2.133l0,0 C403.2,227.2,396.8,224,391.467,227.2l-11.733,7.467c-5.333,3.2-6.4,10.667-2.133,14.933l0,0 C376.533,245.333,377.6,240,381.867,237.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M410.667,244.267L410.667,244.267c2.133,5.333,8.533,8.533,13.867,5.333l0,0 c3.2-2.133,7.467-2.133,9.6,0c3.2,2.133,3.2,1.067,5.333,3.2c0-1.067-1.067-2.133-1.067-2.133c-2.133-3.2-3.2-2.133-6.4-4.267 c-3.2-2.133-6.4-2.133-9.6,0l0,0C418.133,248.533,412.8,247.467,410.667,244.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M379.733,282.667c0-3.2,1.067-7.467,4.267-8.533c5.333-3.2,6.4-10.667,2.133-14.933l0,0 c1.067,4.267,0,8.533-4.267,10.667c-3.2,2.133-5.333,5.333-4.267,8.533c1.067,4.267,0,4.267,2.133,8.533L380.8,288 C379.733,286.933,380.8,285.867,379.733,282.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.067,423.467c19.2,1.067,36.267-12.8,37.333-32c1.067-19.2-14.933-36.267-33.067-36.267 c-4.267,0-3.2,1.067-7.467,2.133c-3.2,1.067-5.333,4.267-6.4,8.533l0,0c0,6.4-6.4,9.6-11.733,8.533l-8.533-3.2 c-5.333-2.133-11.733,2.133-11.733,8.533L134.4,393.6c0,6.4,5.333,10.667,10.667,9.6l9.6-1.067c6.4-1.067,10.667,4.267,10.667,9.6 l0,0c0,3.2,1.067,7.467,4.267,8.533C172.8,422.4,171.733,423.467,177.067,423.467z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M137.6,392.533l1.067-13.867c0-4.267,4.267-8.533,8.533-8.533l0,0 c-5.333-2.133-11.733,2.133-11.733,8.533l-1.067,13.867c0,6.4,5.333,10.667,10.667,9.6l0,0 C139.733,401.067,136.533,397.867,137.6,392.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M158.933,373.333L158.933,373.333c6.4,2.133,11.733-2.133,11.733-8.533l0,0 c0-3.2,2.133-6.4,6.4-8.533c3.2-1.067,3.2-2.133,5.333-2.133c-1.067,0-2.133,0-3.2,0c-4.267,0-3.2,1.067-7.467,2.133 c-3.2,1.067-5.333,4.267-6.4,8.533l0,0C166.4,369.067,163.2,372.267,158.933,373.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M172.8,420.267c-3.2-2.133-5.333-5.333-4.267-8.533c0-6.4-5.333-10.667-10.667-9.6l0,0 c4.267,1.067,7.467,5.333,6.4,9.6c0,3.2,1.067,7.467,4.267,8.533c4.267,2.133,3.2,3.2,8.533,3.2c1.067,0,1.067,0,2.133,0 C176,422.4,176,421.333,172.8,420.267z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.467,284.8c13.867-12.8,14.933-35.2,1.067-49.067c-12.8-13.867-36.267-13.867-50.133,0 c-3.2,3.2-1.067,3.2-3.2,6.4c-1.067,3.2-1.067,7.467,2.133,9.6l0,0c4.267,4.267,3.2,11.733-2.133,14.933l-8.533,4.267 c-5.333,3.2-6.4,9.6-2.133,14.933l9.6,10.667c4.267,4.267,11.733,4.267,14.933-1.067L246.4,288c3.2-5.333,10.667-5.333,14.933-1.067 l0,0c2.133,2.133,6.4,4.267,9.6,2.133C276.267,286.933,276.267,288,279.467,284.8z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M230.4,293.333l-9.6-10.667c-3.2-3.2-3.2-8.533-1.067-11.733l0,0c-5.333,3.2-6.4,9.6-2.133,14.933 l9.6,10.667c4.267,4.267,11.733,4.267,14.933-1.067l0,0C238.933,296.533,233.6,296.533,230.4,293.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M231.467,263.467L231.467,263.467c5.333-3.2,6.4-10.667,2.133-14.933l0,0 c-2.133-2.133-3.2-6.4-2.133-9.6c1.067-3.2,1.067-4.267,2.133-5.333c-1.067,1.067-1.067,1.067-2.133,2.133 c-3.2,3.2-2.133,3.2-3.2,6.4c-1.067,3.2-1.067,7.467,2.133,9.6l0,0C233.6,254.933,233.6,260.267,231.467,263.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M275.2,285.867c-3.2,1.067-7.467,0-9.6-2.133c-4.267-4.267-11.733-4.267-14.933,1.067l0,0 c3.2-2.133,8.533-2.133,11.733,1.067c2.133,2.133,6.4,4.267,9.6,2.133c4.267-1.067,4.267,0,8.533-4.267l1.067-1.067 C279.467,284.8,278.4,284.8,275.2,285.867z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M130.133,201.6c-17.067-8.533-38.4-1.067-45.867,17.067c-8.533,17.067,0,38.4,18.133,45.867 c4.267,2.133,3.2,0,7.467,1.067c3.2,0,6.4-2.133,8.533-5.333l0,0c2.133-5.333,9.6-7.467,13.867-3.2l7.467,5.333 c4.267,4.267,11.733,2.133,13.867-3.2l6.4-12.8c2.133-5.333,0-11.733-6.4-12.8l-9.6-2.133c-5.333-1.067-8.533-7.467-6.4-12.8l0,0 c1.067-3.2,1.067-7.467-1.067-9.6C133.333,204.8,134.4,203.733,130.133,201.6z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M155.733,244.267l-6.4,12.8c-2.133,4.267-6.4,6.4-10.667,5.333l0,0 c4.267,4.267,11.733,2.133,13.867-3.2l6.4-12.8c2.133-5.333,0-11.733-6.4-12.8l0,0C155.733,235.733,157.867,240,155.733,244.267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M128,254.933L128,254.933c-5.333-4.267-11.733-2.133-13.867,3.2l0,0 c-1.067,3.2-5.333,5.333-8.533,5.333s-4.267,1.067-6.4,0c1.067,0,1.067,1.067,2.133,1.067c4.267,2.133,3.2,0,7.467,1.067 c3.2,0,6.4-2.133,8.533-5.333l0,0C119.467,254.933,123.733,253.867,128,254.933z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#231F20"
    },
    d: "M132.267,205.867c2.133,3.2,3.2,6.4,1.067,9.6c-2.133,5.333,0,11.733,6.4,12.8l0,0 c-3.2-2.133-5.333-7.467-3.2-11.733c1.067-3.2,1.067-7.467-1.067-9.6c-3.2-3.2-2.133-4.267-6.4-6.4c0,0-1.067,0-1.067-1.067 C130.133,202.667,130.133,203.733,132.267,205.867z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#231F20",
      enableBackground: "new"
    },
    d: "M261.333,50.133c-60.8,0-115.2,27.733-151.467,70.4 c35.2-29.867,81.067-49.067,130.133-49.067c110.933,0,200.533,89.6,200.533,200.533c0,50.133-18.133,94.933-49.067,130.133 c42.667-36.267,70.4-90.667,70.4-151.467C461.867,139.733,372.267,50.133,261.333,50.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M256,477.867c-122.667,0-221.867-99.2-221.867-221.867S133.333,34.133,256,34.133 S477.867,133.333,477.867,256S378.667,477.867,256,477.867z M256,55.467c-110.933,0-200.533,89.6-200.533,200.533 S145.067,456.533,256,456.533S456.533,366.933,456.533,256S366.933,55.467,256,55.467z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9741ad4442021066ebb0c7ee3aa13a44.svg";
export { ForwardRef as ReactComponent };